import cs from 'classnames';
import React from 'react';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useTuitionSteps } from 'tuition/steps';
import { TuitionApplicationFragment, TuitionErrorField } from '../../generated.graphql';
import { addressErrorFilter } from '../address/AddressForm';
import { TuitionSummaryField } from './TuitionSummaryField';


interface Props {
  application: TuitionApplicationFragment
}


export const AddressSummary = ({ application }: Props) => {
  const steps = useTuitionSteps({slug: slugs.address});
  const errors = application?.validationErrors.filter(addressErrorFilter) || [];
  const isInvalid = errors.length > 0;
  return (
    <SummarySection>
      <SummaryHeader step={steps.this} className={cs(isInvalid && 'text-danger')}>Your Address</SummaryHeader>
      <TuitionSummaryField data={application} field={TuitionErrorField.ResidentialAddress} errors={errors} value={application.residentialAddress?.fullAddress} label="Residential" />
      <TuitionSummaryField data={application} field={TuitionErrorField.DeliveryAddress} errors={errors} value={application.deliveryAddress?.fullAddress || 'Same as my residential address'} label="Delivery" />
    </SummarySection>
  );
}
